import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SaveIcon from "@mui/icons-material/Save";

import {areaForPath, canWrite, isPlayer, readableActions} from "@/utils/access";

import "./index.scss";

const EDIT_ICONS = [
	AddIcon,
	ControlPointIcon,
	DeleteIcon,
	EditIcon,
	FileUploadIcon,
	SaveIcon,
];

// Con la sola lettura sull'area della pagina spariscono inserimento e modifica
export const usePageWritable = () => {
	const user = useSelector((state) => state?.user);
	const location = useLocation();
	return isPlayer(user) || canWrite(user, areaForPath(location.pathname));
};

export const useWritableActions = (actions) => {
	const writable = usePageWritable();
	if (writable) return actions;
	return readableActions(actions, false).filter(
		(a) => !EDIT_ICONS.includes(a?.icon?.type),
	);
};

function MainActions(props) {
	const actions = useWritableActions(props.actions);

	if (!actions?.length && props.actions?.length) return null;

	return (
		<div className="main-actions-container">
			{actions.map((action, key) => {
				return (
					<div key={key} className="main-action">
						<Button
							title={action.title}
							aria-label={action.title || action.label}
							variant={action.variant || "contained"}
							onClick={action.onClick}
							disabled={action.disabled}
							color={action.color || "blue"}
							size="small"
							className={action.label ? undefined : "is-icon"}
						>
							<div className="action-content d-flex align-items-center">
								{action.icon && <div>{action.icon}</div>}
								{action.label && (
									<div className="action-label">{action.label}</div>
								)}
							</div>
						</Button>
					</div>
				);
			})}
		</div>
	);
}

export default MainActions;
